import { render, staticRenderFns } from "./ClientReceiptList.vue?vue&type=template&id=24ed8f9c&scoped=true"
import script from "./ClientReceiptList.vue?vue&type=script&lang=js"
export * from "./ClientReceiptList.vue?vue&type=script&lang=js"
import style0 from "./ClientReceiptList.vue?vue&type=style&index=0&id=24ed8f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed8f9c",
  null
  
)

export default component.exports